import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

@Component({
  selector: 'rto-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.less'],
})
export class NotFoundComponent {
  public appAuthUrl: string = environment.appAuthUrl;
}
